import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { api } from "../api";

const PAGE_LABELS = {
  "/": "Ana Sayfa",
  "/odalar": "Odalar",
  "/hizmetler": "İmkanlar",
  "/videolar": "Videolar",
  "/galeri": "Galeri",
  "/konum": "Konum",
  "/nedenbiz": "Neden Biz",
  "/hakkimizda": "Hakkımızda",
  "/iletisim": "İletişim",
  "/blog": "Blog",
};

const SeoTab = () => {
  const [pages, setPages] = useState(null);
  const [generating, setGenerating] = useState(false);
  const [savingPage, setSavingPage] = useState(null);

  const load = () => api.get("/seo").then(({ data }) => {
    const ordered = Object.keys(PAGE_LABELS).map((p) => {
      const found = (data.pages || []).find((x) => x.page === p);
      return found || { page: p, title: "", description: "", keywords: "" };
    });
    setPages(ordered);
  }).catch(() => setPages([]));
  useEffect(() => { load(); }, []);

  const generate = async () => {
    setGenerating(true);
    try {
      const { data } = await api.post("/admin/seo/generate");
      toast.success(`${data.generated} sayfa için SEO metinleri GPT ile oluşturuldu`);
      load();
    } catch {
      toast.error("Oluşturulamadı, tekrar deneyin");
    } finally {
      setGenerating(false);
    }
  };

  const save = async (p) => {
    setSavingPage(p.page);
    try {
      await api.put("/admin/seo", p);
      toast.success(`${PAGE_LABELS[p.page]} kaydedildi`);
    } catch {
      toast.error("Kaydedilemedi");
    } finally {
      setSavingPage(null);
    }
  };

  if (!pages) return <p className="text-sm text-ink-500">Yükleniyor...</p>;

  return (
    <div data-testid="seo-tab">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-ink-900 sm:text-3xl">SEO Yönetimi</h1>
          <p className="mt-2 text-sm text-ink-500">Her sayfanın meta başlığı ve açıklaması. GPT ile otomatik üretip düzenleyebilirsiniz.</p>
        </div>
        <button onClick={generate} disabled={generating} className="btn-primary disabled:opacity-60" data-testid="seo-generate">
          <Sparkles size={15} />
          {generating ? "GPT yazıyor..." : "GPT ile Tümünü Oluştur"}
        </button>
      </div>

      <div className="mt-8 space-y-5">
        {pages.map((p) => (
          <div key={p.page} className="border border-line bg-white p-5 sm:p-6" data-testid={`seo-page-${p.page === "/" ? "home" : p.page.slice(1)}`}>
            <div className="flex items-center justify-between">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-ink-400">{PAGE_LABELS[p.page]} <span className="font-normal">({p.page})</span></p>
              <button onClick={() => save(p)} disabled={savingPage === p.page}
                className="icon-btn border border-ink-900 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-ink-900 hover:bg-ink-900 hover:text-cream-50 disabled:opacity-50"
                data-testid={`seo-save-${p.page === "/" ? "home" : p.page.slice(1)}`}>
                {savingPage === p.page ? "..." : "Kaydet"}
              </button>
            </div>
            <div className="mt-4 grid gap-4">
              <div>
                <label className="mb-1.5 block text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-400">Meta Başlık ({p.title.length}/60)</label>
                <input value={p.title} onChange={(e) => setPages(pages.map((x) => x.page === p.page ? { ...x, title: e.target.value } : x))}
                  className="input-field" data-testid={`seo-title-${p.page === "/" ? "home" : p.page.slice(1)}`} />
              </div>
              <div>
                <label className="mb-1.5 block text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-400">Meta Açıklama ({p.description.length}/155)</label>
                <textarea rows={2} value={p.description} onChange={(e) => setPages(pages.map((x) => x.page === p.page ? { ...x, description: e.target.value } : x))}
                  className="input-field resize-none" data-testid={`seo-desc-${p.page === "/" ? "home" : p.page.slice(1)}`} />
              </div>
              <div>
                <label className="mb-1.5 block text-[10px] font-semibold uppercase tracking-[0.14em] text-ink-400">Anahtar Kelimeler</label>
                <input value={p.keywords} onChange={(e) => setPages(pages.map((x) => x.page === p.page ? { ...x, keywords: e.target.value } : x))}
                  className="input-field" data-testid={`seo-keywords-${p.page === "/" ? "home" : p.page.slice(1)}`} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SeoTab;
